
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Checkbox, CircularProgress, IconButton, Typography } from '@mui/material'
import { keyframes } from '@mui/system'
import React, { useEffect, useRef, useState } from 'react'
// import StarOutlineIcon from '@mui/icons-material/StarOutline';
// import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
// import StarIcon from '@mui/icons-material/Star';
// import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import { bytesToMegabytes, downloadS3File, fileFormat, getFileType, removeExtension, sizeConverter, timeStampToNumberedDateString } from '../../../utils/commonServices';
import { makeStyles } from "@mui/styles";
import CustomTooltip from '../../../components/CustomTooltip';
import { useDispatch, useSelector } from 'react-redux';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import { useNavigate } from 'react-router-dom';
// import { setAllMediaFilesArray } from '../../../redux/mediaFilesSlice';
// import CustomScrollToBottom from '../../../components/CustomScrollToBottom';
// import { BRANDBOX_OPTIONS } from '../../../constants/staticData';
// import DeleteIcon from '@mui/icons-material/Delete';

import MediaPreview from '../../../components/MediaPreview';
import usePendingVerificationActions from '../usePendingVerificationActions';
import CustomButton from '../../../components/CustomButton';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import EditorAvailabilityToggle from './EditorAvailabilityToggle';

const highlightEntrance = keyframes`
  0%   { box-shadow: none;                              opacity: 0.6; }
  40%  { box-shadow: 0 6px 28px rgba(0,215,68,0.50);   opacity: 1;   }
  70%  { box-shadow: 0 3px 14px rgba(0,215,68,0.25);   }
  85%  { box-shadow: 0 5px 22px rgba(0,215,68,0.40);   }
  100% { box-shadow: 0 4px 20px rgba(0,215,68,0.28);   }
`;

const useStyles = makeStyles((theme) => ({
  checkboxRoot: {
    pointerEvents: 'none',
  },
  container: {
    width: '100%',
    borderCollapse: 'collapse',
    // paddingRight:'4%'
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    '&::-webkit-scrollbar': {
      display: 'none'
    }
  },
  tableRowHead: {
    textAlign: 'left',
    verticalAlign: 'top',
    color: '#08231B',
    fontSize: '15px',
    fontFamily: "Rubik",
    fontWeight: 500,
    letterSpacing: '0.75px',
    zIndex: 15
  },
  tableRowData: {
    borderBottom: '2px solid #EBEBEB',
    // height:{xs:'50px',md:'55px',lg:'60px', xl:'68px'},
    // height:'62px',
    backgroundColor: 'transparent',
    fontFamily: "Rubik",
    // textAlign:'left',
    width: '100%',
    fontSize: '15px',
    padding: '4px',
    paddingRight: '6px',
    // font: 'normal normal 600 15px/18px ',
    fontWeight: 600,
    color: '#08231B',
    letterSpacing: '0.75px',
    zIndex: 15,
    '&:last-child': {
      borderBottom: 'none'
    }
  },

}));

const UsersTable = (props) => {

  const classes = useStyles();
  const { files, popup, expanded, setExpanded, highlightEmail, onActionSuccess } = props
  const userReducer = useSelector((state) => state.userReducer);
  const commonReducer = useSelector((state) => state.root.commonReducer);
  const highlightedRowRef = useRef(null);
  const { resendUnverifiedUserLink, approveUser } = usePendingVerificationActions()

  useEffect(() => {
    if (highlightedRowRef.current) {
      setTimeout(() => {
        highlightedRowRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 300);
    }
  }, [files]);




  return (

    <Box mt={3} className='flex col'>
      <Box sx={{ overflowY: 'scroll', height: popup == true ? '30vh' : '60vh' }}>


        {/* {  userReducer.all_users?.length === 0 ?  <Typography sx={{fontSize: 30, color: '#878887', fontWeight: 300, textAlign: 'center', mt:10}} >No Users to view. </Typography> : 
         <> */}
        <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center' }} mb={{ xs: 2, xl: 3.5 }}>
          <Box style={{ width: '20%' }}><Typography sx={{ fontSize: { xs: '10px', md: '13px', lg: '14.67px', xl: '21px' }, fontFamily: 'Rubik', fontWeight: 800, color: '#08231B' }}>Name</Typography></Box>

          <Box style={{ marginLeft: '1%', width: '20%' }}><Typography textAlign='left' sx={{ fontSize: { xs: '10px', md: '13px', lg: '14.67px', xl: '21px' }, fontFamily: 'Rubik', fontWeight: 800, color: '#08231B' }}>Email</Typography></Box>

          <Box style={{ marginLeft: '1%', width: '20%' }}><Typography textAlign='left' sx={{ fontSize: { xs: '10px', md: '13px', lg: '14.67px', xl: '21px' }, fontFamily: 'Rubik', fontWeight: 800, color: '#08231B' }}>Organization Name</Typography></Box>

          <Box style={{ marginLeft: '1%', width: '15%' }}><Typography textAlign='left' sx={{ fontSize: { xs: '10px', md: '13px', lg: '14.67px', xl: '21px' }, fontFamily: 'Rubik', fontWeight: 800, color: '#08231B' }}>Status</Typography></Box>


          {/* <Box   style={{ marginLeft: '1%',  width: '20%'}}><Typography textAlign='left' sx={{fontSize: {xs:'10px',md:'13px',lg:'14.67px',xl:'21px'}, fontFamily: 'Rubik', fontWeight: 800, color:'#08231B'}}>Action</Typography></Box> */}

          {/* <Box   style={{ marginLeft: '1%',  width: '10%'}}><Typography textAlign='center' sx={{fontSize: {xs:'10px',md:'13px',lg:'14.67px',xl:'21px'}, fontFamily: 'Rubik', fontWeight: 800, color:'#08231B'}}></Typography></Box> */}


          <Box flex={1} sx={{ display: 'flex', minWidth: '15%', justifyContent: 'end' }}  ><Typography sx={{ fontSize: { xs: '10px', md: '13px', lg: '14.67px', xl: '21px' }, fontFamily: 'Rubik', color: '#08231B', display: 'flex', alignItems: 'center', fontWeight: 800, justifyContent: 'end' }}>Action</Typography></Box>
        </Box>
        {/* { */}
        {/* userReducer.all_users?.map((user)=> (  */}

        <Box >
          {(userReducer?.is_loading == true) ? <Box sx={{ width: '100%', mt: 15 }}>
            <Typography variant='h3' textAlign='center'>Loading...</Typography>
          </Box> : files?.length == 0 ? (<Typography textAlign={'center'} mt={'5%'}>{'No users to show'}</Typography>) : files?.map((user, index) => {
            const isHighlighted = highlightEmail && user?.email?.toLowerCase() === highlightEmail.toLowerCase();
            return (
              <React.Fragment key={user?.id}>
                <Box
                  ref={isHighlighted ? highlightedRowRef : null}
                  className={classes.tableRowData}
                  sx={{
                    display: { xs: 'none', md: 'flex' },
                    alignItems: 'center',
                    height: popup == true ? { md: '40px', lg: '45px', xl: '60px' } : { lg: '55px', xl: '65px' },
                    overflowY: 'scroll',
                    position: 'relative',
                    zIndex: isHighlighted ? 2 : 1,
                    borderRadius: isHighlighted ? '8px' : '0px',
                    backgroundColor: isHighlighted ? '#ffffff' : 'transparent',
                    borderLeft: isHighlighted ? '2px solid #00d744' : '4px solid transparent',
                    borderRight: isHighlighted ? '2px solid #00d744' : '4px solid transparent',
                    animation: isHighlighted ? `${highlightEntrance} 0.8s cubic-bezier(0.22,1,0.36,1) forwards` : 'none',
                    boxShadow: isHighlighted ? '0 4px 20px rgba(0,215,68,0.28)' : 'none',
                  }}>


                  <CustomTooltip title={user?.name} >
                    <Box style={{ width: '20%' }}><Typography sx={{ fontSize: { xs: '10px', md: '11px', lg: '13px', xl: '19px' }, whiteSpace: "nowrap", pl: '2px', overflowX: "clip", fontWeight: 400, fontFamily: 'Rubik', cursor: 'pointer' }}>{user?.name}</Typography></Box>
                  </CustomTooltip>

                  <Box style={{ marginLeft: '1%', width: '20%' }}><Typography textAlign='left' sx={{
                    fontSize: { xs: '8px', md: '9px', lg: '11px', xl: '16px' }, fontWeight: 400, fontFamily: 'Rubik', whiteSpace: 'nowrap',
                    overflow: 'hidden', textOverflow: 'ellipsis'
                  }}>{user?.email}</Typography></Box>

                  <Box style={{ marginLeft: '1%', width: '20%' }}><Typography textAlign='left' sx={{
                    fontSize: { xs: '8px', md: '9px', lg: '11px', xl: '16px' }, fontWeight: 400, fontFamily: 'Rubik', whiteSpace: 'nowrap',
                    overflow: 'hidden', textOverflow: 'ellipsis'
                  }}>{user?.organisation_name}</Typography></Box>

                  <Box style={{ marginLeft: '1%', width: '15%' }}><Typography textAlign='left' sx={{ fontSize: { xs: '10px', md: '11px', lg: '13px', xl: '19px' }, fontWeight: 400, fontFamily: 'Rubik' }}>{user?.approved ? 'Unverified' : 'Pending Approval'}</Typography></Box>


                  {/* <Box    style={{ marginLeft: '1%', width:'20%'}}><Typography textAlign='left' sx={{fontSize: {xs:'10px',md:'11px',lg:'13px',xl:'19px'}, fontWeight:400, fontFamily: 'Rubik'}}></Typography></Box> */}





                  <Box flex={1} sx={{ display: 'flex', justifyContent: 'end', alignItems: 'center', minWidth: '15%' }} gap={2}>
                    <EditorAvailabilityToggle user={user} />
                    <Box sx={{ fontSize: { xs: '8px', md: '9px', lg: '11px', xl: '16px' }, display: 'flex', alignItems: 'center', justifyContent: 'end' }} gap={2}>

                      <>
                        {user?.approved ? <>

                          <Button
                            variant='outlined'
                            size='small'
                            onClick={() => resendUnverifiedUserLink({ user_id: user?.id }, isHighlighted ? onActionSuccess : undefined)}
                            startIcon={<ForwardToInboxIcon />}
                            sx={{ textTransform: 'none', fontFamily: 'Rubik', fontWeight: 600, fontSize: { xs: '10px', sm: '10px', md: '11px', lg: '12px', xl: '16px' }, height: { xs: '18px', sm: '18px', md: '20px', lg: '22px', xl: '36px' }, color: '#040504', backgroundColor: '#00ceff', borderRadius: '5px', whiteSpace: 'nowrap', '&:hover': { borderColor: '#020202', color: '#040504', backgroundColor: '#00ceff80' }, '& .MuiButton-startIcon': { mr: { xs: 0.4, lg: 0.5 } } }}
                          >
                            Resend Link
                          </Button>
                        </> : <>
                      
                           <Button
                            variant='outlined'
                            size='small'
                            onClick={() => approveUser({ user_id: user?.id, accepted: true }, isHighlighted ? onActionSuccess : undefined)}
                            startIcon={<CheckCircleOutlineIcon />}
                           style={{borderRadius: '5px', backgroundColor: '#08231B', color:'#00d744', textTransform:'none' }} 
                            sx={{ textTransform: 'none', fontFamily: 'Rubik', fontWeight: 600, fontSize: { xs: '10px', sm: '10px', md: '11px', lg: '12px', xl: '16px' }, height: { xs: '18px', sm: '18px', md: '20px', lg: '22px', xl: '36px' }, borderColor: '#08231B', color: '#08231B', borderRadius: '5px', '&:hover': { borderColor: '#f1f6f2', color: '#00d744', backgroundColor: '#08231B80' }, '& .MuiButton-startIcon': { mr: { xs: 0.4, lg: 0.5 } } }}
                          >
                            Approve
                          </Button> 
                          {/* <Button
                            variant='outlined'
                            size='small'
                            onClick={() => approveUser({ user_id: user?.id, accepted: false })}
                            startIcon={<CancelOutlinedIcon />}
                            sx={{ textTransform: 'none', fontFamily: 'Rubik', fontWeight: 600, fontSize: { xs: '10px', sm: '10px', md: '11px', lg: '12px', xl: '16px' }, height: { xs: '18px', sm: '18px', md: '20px', lg: '22px', xl: '36px' }, borderColor: '#08231B', color: '#08231B', borderRadius: '5px', '&:hover': { borderColor: '#d32f2f', color: '#d32f2f', backgroundColor: 'rgba(211,47,47,0.06)' }, '& .MuiButton-startIcon': { mr: { xs: 0.4, lg: 0.5 } } }}
                          >
                            Reject
                          </Button> */}
                          <Button 
                            variant='outlined' color="button" 
                            onClick={() => approveUser({ user_id: user?.id, accepted: false }, isHighlighted ? onActionSuccess : undefined)}
                            startIcon={<CancelOutlinedIcon />}
                            style={{borderRadius: '5px',  color:   '#d32f2f' }} 
                            sx={{ textTransform: 'none', fontFamily: 'Rubik', fontWeight: 600, fontSize: { xs: '10px', sm: '10px', md: '11px', lg: '12px', xl: '16px' }, height: { xs: '18px', sm: '18px', md: '20px', lg: '22px', xl: '36px' }, borderColor: '#08231B', borderRadius: '5px', whiteSpace: 'nowrap', '&:hover': { borderColor: '#d32f2f', color: '#d32f2f', backgroundColor: 'rgba(211,47,47,0.16)' }, '& .MuiButton-startIcon': { mr: { xs: 0.4, lg: 0.5 } } }}>Reject</Button>
                        </>}
                        {/* { assetReducer?.delete_asset_loading === true && fileId == file?.id ?   <CircularProgress    
                                sx={{
                                  height:'3px', width:'3px',
                                  margin:{xs:0.75,md:0.87,lg:1.1, xl:1.4},
                                  color:'#666'
                                  }}
                                size={14}
                                loading={ assetReducer?.delete_asset_loading === true && fileId == file?.id}
                                disabled 
                              >    
                              </CircularProgress> : <IconButton  
                            disabled = {assetReducer?.delete_asset_loading === true}
                            onClick={()=>deleteFileHandler(file?.id)}
                             sx={{fontSize: {xs:'10px',md:'12px',lg:'15px',xl:'20px'}, '& .MuiSvgIcon-root':{
                            fontSize:{xs:'10px',md:'12px',lg:'15px',xl:'20px'}
                           }}}>
                            <DeleteIcon  sx={{fontSize: {xs:'10px',md:'12px',lg:'15px',xl:'20px'}, '& .MuiSvgIcon-root':{
                            fontSize:{xs:'10px',md:'12px',lg:'15px',xl:'20px'},
                           }}}/>
                         </IconButton>    }    */}

                        {/* <IconButton 
                             disabled = {assetReducer?.delete_asset_loading === true} 
                              onClick={()=>fileownloadHandler(file)} 
                              sx={{fontSize: {xs:'11px',md:'13px',lg:'16px',xl:'21px'}, 
                                  '& .MuiSvgIcon-root':{fontSize:{xs:'11px',md:'13px',lg:'16px',xl:'21px'},}}} 
                            >
                              <FileDownloadOutlinedIcon  sx={{fontSize: {xs:'11px',md:'13px',lg:'16px',xl:'21px'},  '& .MuiSvgIcon-root':{fontSize:{xs:'11px',md:'13px',lg:'16px',xl:'21px'},}}}/>
                            </IconButton> */}
                      </>
                    </Box>
                  </Box>
                </Box>
                {/* Mobile / Tablet Card — visible below md (960px) */}
                <Box
                  sx={{ width: '100%', display: { xs: 'flex', md: 'none' }, flexDirection: 'row', alignItems: 'stretch', borderBottom: '1px solid #EBEBEB', py: 1.5, px: 1, position: 'relative', zIndex: isHighlighted ? 2 : 1, borderRadius: isHighlighted ? '8px' : '0px', backgroundColor: isHighlighted ? '#ffffff' : 'transparent', borderLeft: isHighlighted ? '2px solid #00d744' : '3px solid transparent', borderRight: isHighlighted ? '2px solid #00d744' : '3px solid transparent', animation: isHighlighted ? `${highlightEntrance} 0.8s cubic-bezier(0.22,1,0.36,1) forwards` : 'none', boxShadow: isHighlighted ? '0 4px 20px rgba(0,215,68,0.28)' : 'none' }}
                >
                  {/* Col 1: Name, Email, Org — status badge top-right inside this col */}
                  <Box sx={{ width: '70%', display: 'flex', flexDirection: 'column', pr: 1 }}>
                    {/* Name row + status badge */}
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 0.3 }}>
                      <Typography sx={{ fontFamily: 'Rubik', fontWeight: 600, fontSize: { xs: '12px', sm: '13px' }, color: '#08231B', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', flex: 1, mr: 1 }}>{user?.name}</Typography>
                      <Box sx={{ flexShrink: 0, borderRadius: '10px', px: 1, py: 0.2, backgroundColor: user?.approved ? '#fff3cd' : '#e2e3e5' }}>
                        <Typography sx={{ fontFamily: 'Rubik', fontSize: { xs: '8px', sm: '9px' }, fontWeight: 700, color: user?.approved ? '#856404' : '#383d41', whiteSpace: 'nowrap' }}>{user?.approved ? 'Unverified' : 'Pending Approval'}</Typography>
                      </Box>
                    </Box>
                    <Typography sx={{ fontFamily: 'Rubik', fontSize: { xs: '10px', sm: '11px' }, color: '#555', fontWeight: 400, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', mb: 0.2 }}>{user?.email}</Typography>
                    <Typography sx={{ fontFamily: 'Rubik', fontSize: { xs: '10px', sm: '11px' }, color: '#888', fontWeight: 400, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{user?.organisation_name}</Typography>
                  </Box>
                  {/* Col 2: Action buttons */}
                  <Box sx={{ width: '30%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 0.6, pl: 0.5, borderLeft: '1px solid #EBEBEB' }}>
                    {user?.approved ? (
                      <Button
                        variant='outlined'
                        size='small'
                        onClick={() => resendUnverifiedUserLink({ user_id: user?.id }, isHighlighted ? onActionSuccess : undefined)}
                        startIcon={<ForwardToInboxIcon sx={{ fontSize: '13px !important' }} />}
                        sx={{ textTransform: 'none', fontFamily: 'Rubik', fontWeight: 600, fontSize: '10px', borderColor: '#08231B', color: '#040504', backgroundColor: '#00ceff', borderRadius: '5px', px: 0.8, py: 0.3, minWidth: 0, width: '100%', lineHeight: 1.2, '&:hover': { borderColor: '#020202', color: '#040504', backgroundColor: '#00ceff80' }, '& .MuiButton-startIcon': { mr: 0.4 } }}
                      >
                        Resend
                      </Button>
                    ) : (
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.6, width: '100%', alignItems: 'center' }}>
                        <Button
                          variant='outlined'
                          size='small'
                          onClick={() => approveUser({ user_id: user?.id, accepted: true }, isHighlighted ? onActionSuccess : undefined)}
                          startIcon={<CheckCircleOutlineIcon sx={{ fontSize: '13px !important' }} />}
                           style={{borderRadius: '5px', backgroundColor: '#08231B', color:'#00d744', textTransform:'none' }} 
                          sx={{ textTransform: 'none', fontFamily: 'Rubik', fontWeight: 600, fontSize: '10px', borderColor: '#08231B', color: '#08231B', borderRadius: '5px', px: 0.8, py: 0.3, width: '100%', minWidth: 0, lineHeight: 1.2, '&:hover': { borderColor: '#f1f6f2', color: '#00d744', backgroundColor: '#08231B80'  }, '& .MuiButton-startIcon': { mr: 0.4 } }}
                        >
                          Approve
                        </Button>
                        <Button
                          variant='outlined'
                          size='small'
                          onClick={() => approveUser({ user_id: user?.id, accepted: false }, isHighlighted ? onActionSuccess : undefined)}
                          startIcon={<CancelOutlinedIcon sx={{ fontSize: '13px !important' }} />}
                          style={{borderRadius: '5px',  color:   '#d32f2f' }} 
                          sx={{ textTransform: 'none', fontFamily: 'Rubik', fontWeight: 600, fontSize: '10px', borderColor: '#08231B', color: '#08231B', borderRadius: '5px', px: 0.8, py: 0.3, width: '100%', minWidth: 0, lineHeight: 1.2, '&:hover': { borderColor: '#d32f2f', color: '#d32f2f', backgroundColor: 'rgba(211,47,47,0.16)'  }, '& .MuiButton-startIcon': { mr: 0.4 } }}
                        >
                          Reject
                        </Button>
                      </Box>
                    )}
                  </Box>
                </Box>
              </React.Fragment>
            )
          })}

        </Box>



        {/* </>} */}
      </Box>

    </Box>
  )
}

export default UsersTable